import { useMediaQuery } from "react-responsive";
import { Device } from "../types/device";

const useDevice = () => {
  const isDesktop = useMediaQuery({ minWidth: 1024 });
  const isTablet = useMediaQuery({ minWidth: 768 });

  if (isDesktop) {
    return Device.DESKTOP;
  }
  if (isTablet) {
    return Device.TABLET;
  }
  return Device.MOBILE;
};

export default useDevice;
